// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-m_gO","advertDetailContacts__header":"c-m_gP"};